var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImgVerificationCancel = function SvgImgVerificationCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 54.5,
    fill: "#FFF",
    stroke: "#DBDFE1",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCD0D3",
    fillRule: "nonzero",
    d: "m64.832 71.768 1.344-6.976c.768-3.67 1.43-6.87 1.984-9.6.555-2.73.832-4.736.832-6.016 0-1.621-.448-2.901-1.344-3.84-.896-.939-2.112-1.408-3.648-1.408-1.579 0-2.805.47-3.68 1.408-.875.939-1.312 2.219-1.312 3.84 0 1.323.288 3.35.864 6.08.576 2.73 1.227 5.91 1.952 9.536l1.344 6.976h1.664zM64 87.896c1.493 0 2.763-.512 3.808-1.536s1.568-2.261 1.568-3.712c0-1.493-.523-2.763-1.568-3.808S65.493 77.272 64 77.272c-1.493 0-2.763.523-3.808 1.568s-1.568 2.315-1.568 3.808c0 1.45.523 2.688 1.568 3.712s2.315 1.536 3.808 1.536z"
  }))));
};
export default SvgImgVerificationCancel;